import { Link } from "react-router-dom";
import { useTitle } from "@/lib/format";

export default function NotFound() {
  useTitle("Page not found");
  return (
    <div className="mx-auto max-w-xl px-4 py-24 text-center" data-testid="not-found-page">
      <p className="font-heading text-6xl font-extrabold text-sky-600">404</p>
      <h1 className="mt-4 text-2xl font-bold text-slate-900">We couldn't find that page</h1>
      <Link to="/" className="mt-8 inline-flex h-12 items-center rounded-xl bg-sky-600 px-6 font-semibold text-white" data-testid="back-home-link">Back to home</Link>
    </div>
  );
}
